import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Nav, NavItem } from 'reactstrap';
import classNames from 'classnames';

const MenuItems = props => {
  const { items, location, ...rest } = props;
  return (
    <Nav
      {...rest}
    >
      {items.map((item, index) => {
        const {
          text = '',
          to = '#',
          subItems = [],
          active,
          icon,
          ...itemProps
        } = item;
        return (
          <NavItem
            className={classNames({
              'active': active ||
                ((location && location.pathname === to) ||
                  subItems.find(
                    subItem => location && location.pathname === subItem.to
                  )),
              'has-sub-menu': subItems.length
            })}
            key={index}
          >
            <Link
              to={to}
              className={classNames(
                'nav-link d-flex align-items-center',
                active || (location && location.pathname === to)
                  ? 'active'
                  : ''
              )}
              {...itemProps}
            >
              {icon && <span className="m-0 ml-2 h4">{icon}</span>}
              <span>{text}</span>
            </Link>
            {subItems.length ? (
              <MenuItems
                className="sub-menu"
                items={subItems}
                vertical
                location={location}
              />
            ) : null}
          </NavItem>
        );
      })}
    </Nav>
  )
}

const Menu = props => {
  const { id = '', className, style={}, isDesktop, dispatch, forwardedRef, ...rest } = props;
  return (
    <nav className={classNames(className, { desktop: isDesktop })} id={id} style={style} ref={forwardedRef}>
      <MenuItems {...rest} />
    </nav>

  );
};

const ConnectedMenu =  connect(
  state => ({
    location: state.router.location
  })
)(Menu)

export default React.forwardRef((props, ref) => <ConnectedMenu {...props} forwardedRef={ref} />)

Menu.propTypes = {
  items: PropTypes.array.isRequired,
  vertical: PropTypes.bool,
  className: PropTypes.string,
  location: PropTypes.object
};

Menu.defaultProps = {
  className: '',
  vertical: false,
  location: null
};
